<script lang="ts">
  import PublicAppBar from '$lib/components/PublicAppBar.svelte'
  import { LinearProgress, type Theme } from '@bond/components'
  import type { LayoutData } from './$types'
  import { navigating } from '$app/stores'
  import { writable, type Writable } from 'svelte/store'
  import Footer from '$lib/components/Footer.svelte'
  import CookieDialog from '$lib/components/CookieDialog.svelte'
  import { initTracking } from '$lib/utils/tracking/init'
  import { browser } from '$app/environment'
  import CampaignBanner from '$lib/components/CampaignBanner.svelte'
  import CampaignFooter from '$lib/components/CampaignFooter.svelte'

  export let data: LayoutData

  $: ({
    lang,
    trial,
    countries,
    currentCity,
    storedConsent,
    storedTheme,
    campaign,
  } = data)

  let theme: Writable<Theme | null> = writable(storedTheme ?? null)

  $: if (!$theme && storedTheme) {
    theme.set(storedTheme)
  }

  $: if (storedConsent === 'accept' && browser) {
    initTracking()
  }

  $: src =
    $theme === 'dark'
      ? '/images/bruce-studios-logo-white.svg'
      : '/images/bruce-studios-logo-black.svg'
</script>

<PublicAppBar
  {src}
  {lang}
  {trial}
  {storedTheme}
  currentCity={currentCity?.name}
  bind:theme
/>
<div class="content">
  <LinearProgress indeterminate fixed active={Boolean($navigating)} />
  {#if campaign}
    <CampaignBanner {campaign} />
  {/if}
  <main>
    <CookieDialog
      country={countries.find(
        (country) => country.id === currentCity?.country_id,
      )}
      closed={Boolean(storedConsent)}
    />
    <slot />
  </main>
  {#if campaign?.footer}
    <CampaignFooter text={campaign.footer} />
  {/if}
  <Footer {lang} {src} {storedTheme} {theme} />
</div>

<style lang="scss">
  .content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: var(--appbar-height);
    min-height: calc(100vh - var(--appbar-height));
  }

  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0 auto 2em auto;
    flex: 1;
  }
</style>
